import React from "react";
import { Link, useNavigate } from "react-router-dom";
import heroImg from "../../../../assets/images/Landing/images/web-dev.svg";
import styles from "./Hero.module.css";
import { useAuth } from "../../../../contexts/AuthContext";

const Hero = () => {
  const { accessToken, showLoginModal } = useAuth();
  const navigate = useNavigate();

  const handleOpenAccount = (e) => {
    e.preventDefault();
    
    if (accessToken) {
      // User is already logged in, redirect directly to onboarding
      navigate('/realtor-onbaord');
    } else {
      // User is not logged in, store return path and show login modal
      sessionStorage.setItem('returnPath', '/realtor-onbaord');
      showLoginModal();
    }
  };

  return (
    <>
      <div className={styles.hero} id="hero">
        <div data-aos="zoom-in">
          <div
            className={`${styles.heroContainer} lg:${styles.heroContainerLg}`}
          >
            <div
              className={`${styles.heroTextContainer} lg:${styles.heroTextContainerLg}`}
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <h1
                className={`${styles.heroHeading} md:${styles.heroHeadingMd}`}
              >
                Elevate Your Real Estate Career with FirstLand
              </h1>
              <h1>
                <div className={styles.heroSubText}>
                  Join a platform designed for real estate professionals to
                  showcase your expertise, expand your reach, and close more
                  deals faster. With powerful AI-driven tools, real-time
                  analytics, and automated marketing solutions, FirstLand
                  empowers you to build your brand and stand out in the
                  competitive market.
                </div>
              </h1>
              <div className={styles.buttonGroup}>
                <a href="#" onClick={handleOpenAccount} className={styles.button}>
                  Open New Account
                  <svg
                    className={styles.icon}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
            <div
              className={`${styles.heroImg} lg:${styles.heroImgLg}`}
              data-aos="fade-up"
              data-aos-delay="700"
            >
              <img alt="card img" className={styles.heroImg} src={heroImg} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
